import { Directive } from '@angular/core';
import { NG_VALIDATORS, Validator, FormControl } from '@angular/forms';
import { isNullOrUndefined } from './objectUtils';
import  JSBI  from 'jsbi'

@Directive({
    selector: 'input[ibanValidation]',
    providers: [{ provide: NG_VALIDATORS, useExisting: IBANValidationDirective, multi: true }],
    standalone: false
})
export class IBANValidationDirective implements Validator {

  validate(c: FormControl): { [key: string]: any } {
    const obj = { 'invalidIBAN': true };
    const objIban = { 'invalidIBANSpace': true };
    var ibanAsString: string = (typeof c.value) === 'string' ? c.value : c.value?.toString();
    if (isNullOrUndefined(ibanAsString))
      return null;
    if (ibanAsString.search(" ") != -1)
      return objIban;
    ibanAsString = ibanAsString?.replace(" ", "").toUpperCase();
    //Para nao validar estrangeiros e permitir a outra regra de starts with PT50 já existente
    if (!ibanAsString.startsWith("PT50"))
      return null;
    if (ibanAsString.length != 25)
      return obj;
    ibanAsString  = ibanAsString.slice(3, 25);
    ibanAsString += "252950";

    var ibanAsNumber;
    try {
      ibanAsNumber = JSBI.BigInt(ibanAsString);
    }
    catch (e) {
      return obj;
    }
    
    //if (ibanAsNumber == BigInt(NaN))
     // return obj;

    const control = JSBI.remainder(ibanAsNumber, JSBI.BigInt(97))//ibanAsNumber % BigInt(97);
    return !JSBI.equal(control,JSBI.BigInt(1)) ? { 'invalidIBAN': true } : null;
  }
}
